import React from 'react';
import PropTypes from 'prop-types';
import { Avatar as AntAvatar, Dropdown, Menu } from 'antd';
import classNames from 'classnames';
import { parseFullName } from 'parse-full-name';
import Typography from '../Typography/index';
import './avatar.scss';
import COLORS from '../../util/constants/colors';
import { SignOut } from '@phosphor-icons/react';
import { connect } from 'react-redux';
import { logout } from '../../actions/auth';

const Avatar = ({
  size,
  online,
  content,
  name,
  org,
  email,
  full,
  header,
  logout,
  ...props
}) => {
  const AvatarInfo = () => {
    const parsedName = parseFullName(name);
    const firstName = parsedName.first || parsedName.last;

    return (
      <div className="avatar-info">
        {
          size === 'small' ? (
            <>
              { name && <Typography variant="text" size="small" bold color={COLORS.TEXT_SECONDARY_LITE}>{firstName}</Typography> }
              { org && <Typography variant="text" size="xsmall" color={COLORS.TEXT_TERTIARY_LITE}>{org}</Typography> }
            </>
          ) : (
            <>
              { name && (
              <Typography variant="text" size="large" bold>
                Hello, {firstName}
              </Typography>
              ) }
              { org && <Typography variant="text" size="medium" bold color={COLORS.TEXT_TERTIARY_LITE}>{org}</Typography> }
              { email && <Typography variant="text" size="small" color={COLORS.TEXT_TERTIARY_LITE}>{email}</Typography> }
            </>
          )
        }
      </div>
    );
  };

  const avatarSize = size === 'small' ? 32 : 48;

  const AvatarComponent = (
    <div className={classNames('avatar', { full, header })}>
      <div className="avatar-icon">
        <AntAvatar size={avatarSize} style={{ backgroundColor: COLORS.ORANGE_PRIMARY_LITE }} {...props}>
          {content}
        </AntAvatar>
        { online && (<div className={classNames('online-dot', { [size]: size })} />) }
      </div>
      <AvatarInfo />
    </div>
  );

  if (header) {
    return (
      <Dropdown
        trigger={['click']}
        overlay={
          <Menu>
            <Menu.Item key="logout" onClick={() => logout()}>
              <span className="logout-item">
                <SignOut size={16} weight="bold" fill={COLORS.PURPLE_PRIMARY_LITE}/>
                <Typography variant="text" size="small">
                  Logout
                </Typography>
              </span>
            </Menu.Item>
          </Menu>
        }
      >
          {AvatarComponent}
        </Dropdown>
      );
  }

  return AvatarComponent;
};

Avatar.defaultProps = {
  size: 'small',
  online: false,
  org: '',
  email: '',
  full: false,
  header: false,
  logout: () => {},
};

Avatar.propTypes = {
  size: PropTypes.string,
  online: PropTypes.bool,
  content: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  org: PropTypes.string,
  email: PropTypes.string,
  full: PropTypes.bool,
  header: PropTypes.bool,
  logout: PropTypes.func,
};

export default connect(null, { logout })(Avatar);
